import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
});

export function VanFastIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="m7 4h-6c-.553 0-1-.447-1-1s.447-1 1-1h6c.553 0 1 .447 1 1s-.447 1-1 1zm-1 3c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1s.447 1 1 1h4c.553 0 1-.447 1-1zm-2 4c0-.553-.447-1-1-1h-2c-.553 0-1 .447-1 1s.447 1 1 1h2c.553 0 1-.447 1-1zm9-9h-3.184c.112.314.184.648.184 1 0 1.302-.839 2.402-2 2.816v4.184h5zm7.97 2.97c-.802-1.804-2.595-2.97-4.569-2.97h-1.4v8h8.205zm-17.912 15.03c-.034.162-.058.328-.058.5 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-.172-.024-.338-.058-.5zm13 0c-.034.162-.058.328-.058.5 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-.172-.024-.338-.058-.5h-4.885zm7.827-8h-18.069c-.414 1.161-1.514 2-2.816 2h-3c0 2.206 1.794 4 4 4h16c2.206 0 4-1.794 4-4v-.727c0-.431-.039-.856-.116-1.273z" />
    </svg>
  );
}

export function ShieldKeyholeIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="m18.573,2.126L12.314.051c-.203-.068-.426-.068-.629,0l-6.259,2.075c-2.05.68-3.427,2.587-3.427,4.746v5.171c0,6.563,7.005,10.577,9.152,11.65,0,0,.467.307.85.307s.791-.24.791-.24c2.16-.869,9.207-4.281,9.207-11.717v-5.171c0-2.159-1.377-4.066-3.427-4.746Zm-5.573,9.665v3.209c0,.553-.447,1-1,1s-1-.447-1-1v-3.209c-.883-.386-1.5-1.266-1.5-2.291,0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5c0,1.025-.617,1.906-1.5,2.291Z" />
    </svg>
  );
}

export function BoxAltIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="m10 6v-6h4v6a2 2 0 0 1 -4 0zm6-1h8a5.006 5.006 0 0 0 -5-5h-3zm-8-5h-3a5.006 5.006 0 0 0 -5 5h8zm16 7v12a5.006 5.006 0 0 1 -5 5h-14a5.006 5.006 0 0 1 -5-5v-12h8.142a3.981 3.981 0 0 0 7.716 0zm-4 12a1 1 0 0 0 -1-1h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1z" />
    </svg>
  );
}

export function StarFilledIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M1.327,12.4,4.887,15,3.535,19.187A3.178,3.178,0,0,0,4.719,22.8a3.177,3.177,0,0,0,3.8-.019L12,20.219l3.482,2.559a3.227,3.227,0,0,0,4.983-3.591L19.113,15l3.56-2.6a3.227,3.227,0,0,0-1.9-5.832H16.4L15.073,2.432a3.227,3.227,0,0,0-6.146,0L7.6,6.568H3.231a3.227,3.227,0,0,0-1.9,5.832Z" />
    </svg>
  );
}
